import Reveal from "./Reveal";

/**
 * Eyebrow + H2 (+ optional lead text and a right-aligned action). One
 * implementation for every homepage section so the type hierarchy is identical
 * everywhere: eyebrow 12px caps, H2 36→52px, lead 16–18px.
 */
export default function SectionHeader({ eyebrow, title, titleId, description, action, tone = "light", align = "left", className = "" }) {
  const dark = tone === "dark";
  const center = align === "center";
  // A plain-string title breaks onto one line per sentence ("Advanced Tools. / Reliable Results.").
  const lines = typeof title === "string" ? title.trim().split(/(?<=[.!?])\s+/).filter(Boolean) : null;
  return (
    <Reveal className={`flex flex-col gap-6 ${center ? "items-center text-center" : "md:flex-row md:items-end md:justify-between"} ${className}`}>
      <div className={center ? "max-w-3xl" : "max-w-2xl"}>
        {eyebrow && (
          <div className={`mb-4 flex items-center gap-3 text-[12px] font-semibold uppercase tracking-[0.2em] ${center ? "justify-center" : ""}`} style={{ color: dark ? "#6EA2FF" : "#1769FF" }}>
            <span className="h-px w-8" style={{ backgroundColor: dark ? "#6EA2FF" : "#1769FF" }} aria-hidden="true" />
            {eyebrow}
          </div>
        )}
        <h2 className={`font-heading text-[34px] font-semibold leading-[1.1] tracking-[-0.02em] sm:text-[42px] lg:text-[52px] ${dark ? "text-white" : "text-[#13233F]"}`} id={titleId}>{lines ? lines.map((l) => <span key={l} className="block">{l}</span>) : title}</h2>
        {description && <p className={`mt-5 text-base leading-relaxed lg:text-lg ${dark ? "text-white/70" : "text-[#667085]"}`}>{description}</p>}
      </div>
      {action}
    </Reveal>
  );
}
